module.exports = __webpack_public_path__ + "static/code_ux_audit-41a7502ba86492bea05848e4ab69bce6.png";